<template>
  <div
    class="fa-width-auto ovp-basket-widget ovp-a11y-container"
    :app-language="selectedLanguage"
    :app-name="appName$"
    :app-version="version$"
  >
    <basket-wrapper />
  </div>
</template>

<script setup>
  import { inject } from 'vue'

  import useI18n from '@shared/hooks/useI18n'

  import BasketWrapper from '@shared/components/BasketWidget/BasketWrapper'

  // HOOKS
  const { selectedLanguage } = useI18n()

  // INIT
  const appName$ = inject('appName$')
  const version$ = inject('version$')
</script>

<style>
/* note: is needed for dotcom */
.dotcom__header--transparent:not(.dotcom__header--sticky):not(.dotcom__header--hovered):not(.dotcom__header--focused)
  .trigger {
  color: var(--colors-primary-1000) !important;
}

.dotcom__nav-button__premium-calculator {
  margin-top: 7px;
}
</style>

<style scoped>
.ovp-basket-widget {
  .basket__widget {
    .trigger,
    :deep(.trigger) {
      background: none;
      border: none;
      font-size: 28px;
      color: var(--on-surface);
      position: relative;
      display: inline-block;

      padding: 0;
      padding-inline: 0;
      padding-block: 0;

      &:hover {
        cursor: pointer;
        color: var(--Interaction-States-pressed-default-a);
      }
    }

    .badge {
      position: absolute;
      top: 4px;
      right: 0;
      background-color: var(--primary);
      color: var(--on-attention);
      border-radius: 50%;
      font-size: 12px;
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 16px;
      box-sizing: content-box;
      box-shadow: 0 0 0 3px var(--surface-ext-b-low);
    }
  }
}
</style>
